import request from '@/utils/request'

export function updateRecallCfg(data) {
  return request({
    url: 'api/v1/recall-config/update',
    method: 'post',
    data: data
  })
}

export function getRecallList(data) {
  return request({
    url: 'api/v1/recall-config/getList',
    method: 'post',
    data: data
  })
}

export function exportRecall(data) {
  return request({
    url: 'api/v1/recall-config/export',
    method: 'post',
    data: data
  })
}

export function importRecall(data) {
  return request({
    url: 'api/v1/recall-config/import',
    method: 'post',
    data: data
  })
}

export function delRecall(data) {
  return request({
    url: 'api/v1/recall-config/delete',
    method: 'delete',
    data: data
  })
}

export function uploadRecallJson(data) {
  return request({
    url: 'api/v1/recall-config/updateCdn',
    method: 'post',
    data: data,
    timeout: 50000
  })
}
